export function applyTheme(theme) {
  const root = document.documentElement;
  const colorVars = {
    "--royal": theme.colors.royalBlue,
    "--gold": theme.colors.goldYellow,
    "--orange": theme.colors.redOrange,
    "--ivory": theme.colors.creamIvory,
    "--maroon": theme.colors.deepMaroon,
    "--ink": theme.colors.ink,
    "--muted": theme.colors.muted,
    "--surface": theme.colors.surface,
    "--surface-soft": theme.colors.surfaceSoft,
    "--line": theme.colors.line,
    "--success": theme.colors.success,
    "--hero-gradient": theme.gradients.hero,
    "--premium-gradient": theme.gradients.premium,
    "--cta-gradient": theme.gradients.cta
  };
  Object.entries(colorVars).forEach(([key, value]) => root.style.setProperty(key, value));
}

export function formatMoney(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0
  }).format(Number.isFinite(amount) ? amount : 0);
}

export function setSeo({ title, description, keywords, image, url }) {
  document.title = title;
  const entries = [
    ["description", description],
    ["keywords", keywords.join(", ")],
    ["og:title", title, "property"],
    ["og:description", description, "property"],
    ["og:image", image, "property"],
    ["og:url", url, "property"],
    ["twitter:card", "summary_large_image"],
    ["twitter:title", title],
    ["twitter:description", description],
    ["twitter:image", image]
  ];

  entries.forEach(([name, content, attr = "name"]) => {
    let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  });
}

export function productStats(products) {
  const rates = products.map((item) => item.interestRate).filter(Boolean);
  return {
    count: products.length,
    bestRate: rates.length ? Math.max(...rates) : 0
  };
}
